import api from './api';
import { downloadFromApi } from './download';

/**
 * Appels du « Compte partenaire »: les mouvements d'une société (acomptes de
 * lot, avances de loyer, décomptes, états de paiement, loyers, saisies
 * directes) lus dans le journal de la finance, jamais saisis ici.
 *
 * Aucun libellé d'écran dans ce fichier; les noms de fichier viennent du serveur.
 */
const PDF = 'application/pdf';

/** Le corps d'une réponse, avec ou sans l'enveloppe `{ data }`. */
const corps = (reponse) => {
  const brut = reponse?.data;
  if (
    brut &&
    typeof brut === 'object' &&
    brut.data &&
    typeof brut.data === 'object' &&
    !('items' in brut) &&
    !('summary' in brut)
  ) {
    return brut.data;
  }
  return brut ?? null;
};

const sansVides = (params) =>
  Object.fromEntries(Object.entries(params || {}).filter(([, valeur]) => valeur !== '' && valeur != null));

export const partnerAccountAPI = {
  /** Le compte d'une société: synthèse, solde d'ouverture et une page de lignes. */
  async compte(societeId, params = {}) {
    return corps(await api.get(`/companies/${encodeURIComponent(societeId)}/account`, { params: sansVides(params) }));
  },

  /** Reste dû de plusieurs sociétés d'un seul appel (une page de la liste des sociétés). */
  async soldes(societeIds = []) {
    const ids = [...new Set(societeIds.filter(Boolean))];
    if (ids.length === 0) return { items: [], total: null };
    return corps(await api.get('/companies/account-balances', { params: { company_ids: ids.join(',') } }));
  },

  /** Crée ou relie le tiers fournisseur de la société; rend son identifiant. */
  async preparerTiers(societeId) {
    const donnees = corps(await api.post(`/companies/${encodeURIComponent(societeId)}/account/party`));
    return donnees?.party_id || null;
  },

  /** Relevé de compte signable, en PDF; rend le nom de fichier choisi par le serveur. */
  telechargerReleve(societeId, { du, au } = {}) {
    return downloadFromApi(
      `/companies/${encodeURIComponent(societeId)}/account/statement`,
      sansVides({ du, au }),
      'releve-de-compte.pdf',
      PDF,
    );
  },

  /** Adresse et paramètres de la feuille du compte, pour le menu d'impression. */
  feuille(societeId, { du, au } = {}) {
    return {
      url: `/companies/${encodeURIComponent(societeId)}/account/print`,
      params: sansVides({ du, au }),
    };
  },
};

export default partnerAccountAPI;
